import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20Korean%20manhwa%20style%20panorama%2C%20flowing%20ink%20and%20watercolor%20composition%20with%20warm%20coral%20and%20amber%20tones%2C%20dynamic%20splashes%20and%20swirling%20lines%20suggesting%20comic%20action%20scenes%2C%20dreamy%20and%20dramatic%20atmosphere%2C%20wide%20horizontal%20format%2C%20soft%20gradient%20transitions%2C%20no%20text%2C%20no%20characters&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="韩漫画网 - 最新高清免费韩国漫画大全"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white text-center max-w-3xl leading-tight">
          漫画免费韩漫 · 最新高清免费韩国漫画大全
        </h1>
        <p className="mt-4 md:mt-6 text-sm md:text-base text-white/80 text-center max-w-2xl leading-relaxed">
          韩漫画网提供最全面的<strong>漫画免费韩漫</strong>服务，收录最新高清<strong>免费韩国漫画大全</strong>与<strong>热门韩漫</strong>作品，支持<strong>在线阅读</strong>，随时随地满足您的追更需求
        </p>
        <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-sm transition-all whitespace-nowrap cursor-pointer"
          >
            开始阅读
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full text-sm backdrop-blur-sm transition-all whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
        <div className="mt-8 md:mt-10 flex items-center gap-6 text-white/70 text-xs md:text-sm">
          <span className="flex items-center gap-1">
            <i className="ri-book-2-line"></i>
            2000+ 部韩漫
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-user-smile-line"></i>
            500万+ 读者
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-shield-check-line"></i>
            正版授权
          </span>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex justify-center">
          <div className="w-1.5 h-3 bg-white/60 rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}